<div class="grid-layout first-row">
  <app-edit-transport-weekoverview [class.not-available]="!selectedTimeRecord"
    [gridDataSource]="transportWeekOverview"
    [setWeekNo]="selectedWeekNo"
    [height]="242"
    [widthTimeTypeCategory]="150"
    [overTimeCheckActive]="overTimeCheckActive"
    [showTitle]="false"
    [customTitle]="weekOverview[0]?.title">
  </app-edit-transport-weekoverview>

  <app-elevation-section [title]="languageService.LNG('Label.Hours')" [initialHeight]="false" [removePadding]="true">
    <app-time-log [height]="282"
      [timeLog]="times"
      [selectedTimeRecord]="selectedTimeRecord"
      [employees]="employees">
    </app-time-log>
  </app-elevation-section>

  <app-project-portal-approval-employee-expenses #projectApprovalExpenses [class.not-available]="!selectedTimeRecord"
    [hidden]="!gridSections.ShowExpenses"
    [expenses]="expenses"
    [expenseTypes]="expenseTypes"
    [selectedTimeRecord]="selectedTimeRecord"
    [allowEdit]="projectReadWriteAll"
    [timeSalaryTimeComponent]="timeSalaryTimeComponent"
    (cellPrepared)="cellPrepared.emit($event)"
    [portalType]="portalType"
    [selectedProjectId]="selectedProjectId"
    [projectReadAll]="projectReadAll || projectReadWriteAll">
  </app-project-portal-approval-employee-expenses>
</div>

<div class="grid-layout second-row">
  <app-project-portal-approval-employee-additions #projectApprovalAdditions
    [hidden]="!gridSections.ShowAdditions"  
    [boxHeight]="185"
    [additions]="additions"
    [additionTypes]="additionTypes"
    [selectedTimeRecord]="selectedTimeRecord"
    [allowEdit]="projectReadWriteAll || employeeHasProjectPermissions"
    [timeSalaryTimeComponent]="timeSalaryTimeComponent"
    (cellPrepared)="cellPrepared.emit($event)"
    [portalType]="portalType"
    [selectedProjectId]="selectedProjectId"
    [projectReadAll]="projectReadAll || projectReadWriteAll">
  </app-project-portal-approval-employee-additions>

  <app-project-portal-approval-employee-equipments [class.not-available]="!selectedTimeRecord"
    [hidden]="!gridSections?.ShowEquipments"
    [equipments]="equipments"
    [transportEquipments]="transportEquipments"
    [transport]="transport"
    [selectedTimeRecord]="selectedTimeRecord"
    [allowEdit]="(projectReadWriteAll || employeeHasProjectPermissions) && selectedTimeRecord">
  </app-project-portal-approval-employee-equipments>

  <app-project-portal-approval-employee-articles [class.not-available]="!selectedTimeRecord"
    [hidden]="!gridSections.ShowArticles"
    [articles]="articles"
    [articleTypes]="transportArticleTypes"
    [selectedTimeRecord]="selectedTimeRecord"
    [transport]="transport"
    [allowEdit]="(projectReadWriteAll || employeeHasProjectPermissions) && selectedTimeRecord">
  </app-project-portal-approval-employee-articles>
</div>